module.exports = __webpack_public_path__ + "img/stepan.26fc6aaa.jpg";